// extracted by mini-css-extract-plugin
export default {"client":"styles_client__pAP8-","main_section":"styles_main_section__DiRiN","left_banner":"styles_left_banner__SsQ2D","right_section":"styles_right_section__uO05k"};